import "es6-shim";
import * as React from 'react';
import { Modal } from 'react-bootstrap';
import "../../styles/Popup.css";
import { ReactNode } from "react";

interface IPopupProps {
    visible: boolean,
    title: string,
    message?: ReactNode,
    largeSize?: string,
    closeButtonText: string,
    children?: ReactNode
    hidepopup(): void
}
export const Popup = (props: IPopupProps) => {
    return (
        <div>
            <Modal
                onHide={props.hidepopup}
                show={props.visible}
                backdrop="static"
                keyboard={false}
                dialogClassName={props.largeSize ? "customModal-50percent" : null}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-lg" style={{ fontSize: "30px", textAlign: "left", color: "#063769" }}>
                        {props.title.toUpperCase()}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ textAlign: "center" }}>
                    {
                        props.message &&
                        <h2>{props.message}</h2>
                    }
                    {props.children}
                </Modal.Body>

                <Modal.Footer>
                    <div className="col-sm-12 text-center">
                        <button
                            className="buttons-blue"
                            onClick={(e) => { e.preventDefault(); props.hidepopup(); }}
                        >
                            {props.closeButtonText}
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/genericComponents/Popup.tsx